import { toCamelCase } from '@cli-utils/text.js'

export function deriveFieldNameFromLabel(label: string): string {
  const stripped = label
    .trim()
    .replace(/['"]/g, '')
    .replace(/[^A-Za-z0-9_\s-]+/g, ' ')

  return toCamelCase(stripped.trim() || 'field')
}
